import { Navbar, Footer } from '@/components/marketing';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { Search, Book, Code, Video, MessageSquare, FileText, ArrowRight } from 'lucide-react';

const docCategories = [
  {
    icon: Book,
    title: 'Getting Started',
    description: 'Learn the basics of SparkCommerce',
    links: ['Quick Start Guide', 'Account Setup', 'First Sale', 'WhatsApp Connection'],
  },
  {
    icon: MessageSquare,
    title: 'WhatsApp Integration',
    description: 'Set up and customize WhatsApp',
    links: ['Connect WhatsApp Business', 'AI Configuration', 'Message Templates', 'Automation Rules'],
  },
  {
    icon: Code,
    title: 'API Reference',
    description: 'Integrate with our REST API',
    links: ['Authentication', 'Products API', 'Orders API', 'Webhooks'],
  },
  {
    icon: Video,
    title: 'Video Tutorials',
    description: 'Watch step-by-step guides',
    links: ['Platform Overview', 'POS Tutorial', 'Inventory Management', 'Reports Guide'],
  },
  {
    icon: FileText,
    title: 'Best Practices',
    description: 'Tips for success',
    links: ['Catalog Optimization', 'AI Training Tips', 'Customer Service', 'Growth Strategies'],
  },
];

export default function DocsPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-32 pb-16 bg-muted/30">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl lg:text-5xl font-bold mb-6">
              Documentation
            </h1>
            <p className="text-lg text-muted-foreground mb-8">
              Everything you need to know about SparkCommerce
            </p>
            <div className="relative max-w-xl mx-auto">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
              <Input
                placeholder="Search documentation..."
                className="pl-12 h-12 text-base"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Doc Categories */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {docCategories.map((category) => {
              const Icon = category.icon;
              return (
                <Card key={category.title} className="hover:border-primary/50 transition-colors">
                  <CardHeader>
                    <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-2">
                      <Icon className="w-5 h-5 text-primary" />
                    </div>
                    <CardTitle>{category.title}</CardTitle>
                    <CardDescription>{category.description}</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <ul className="space-y-2">
                      {category.links.map((link) => (
                        <li key={link}>
                          <a
                            href="#"
                            className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
                          >
                            <ArrowRight className="w-3 h-3" />
                            {link}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Help CTA */}
      <section className="py-16 bg-muted/30">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-2xl font-bold mb-4">Need Help?</h2>
            <p className="text-muted-foreground mb-6">
              Can't find what you're looking for? Our support team is here to help.
            </p>
            <Button>Contact Support</Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
